import { Component, inject } from '@angular/core';
import {
  CalendarInputComponent,
  NumberInputComponent,
  SelectInputComponent,
} from '@navstation-portal/shared/ui/components';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { TIMEZONE_SELECT_OPTIONS } from '@navstation-portal/shared/util/time';

@Component({
  selector: 're-report-time',
  standalone: true,
  templateUrl: './report-time.component.html',
  imports: [
    FormsModule,
    NumberInputComponent,
    CalendarInputComponent,
    SelectInputComponent,
    IsVisibleDirective,
  ],
})
export class ReportTimeComponent extends AbstractStoreConnectedSectionComponent {
  timezoneOptions = TIMEZONE_SELECT_OPTIONS;
  tabId = 'operational';
  sectionId = 'reportTime';
  events = injectDispatch(offshoreOperationalEvents);
  store = inject(OffshoreOperationalFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
